export default __webpack_public_path__ + "static/media/open.8e444f49.png";